module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/duke-7c1425d59d4b8a737bf09f68bd21f1ea.png";